<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XaO81t/tc-custom/9781630473327.jpg?1696811664038" alt="This image is the cover for the book Focus on Impact"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Focus on Impact
      </h1>
      <p class="bookDescription body article font2">
        <p>Never in the history of capitalism has there been a greater need for a shift in business focus. Consumers are cynical, skeptical and cautious, opening a new opportunity for difference-makers. We need to move away from the traditional money-driven business focus and focus all product design, marketing and delivery on making an immediate and lasting impact on people’s lives. This how-to manual provides proven strategies to build and grow any retail or service business that’s focused on impact with step-by-step, proven formulas to make it happen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy Lipton-Dibner
      </h2>
      
      <p class="authorDescription body article">WENDY LIPTON-DIBNER, MA is a multiple-time bestselling author and internationally recognized authority in business acceleration through impact strategy. President of Professional Impact & founder of Professional Impact Academy and the Move People to Action System for Global Impact, Wendy is a world-class speaker, sought-after media guest and trusted advisor to doctors, executives, entrepreneurs & top influencers worldwide. She’s addressed the U.S. Senate & delivered thousands of programs on business growth for Fortune 100, healthcare, small business and non-profit organizations, touching millions of lives around the globe.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Moran James
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6623e98d